export enum Role {
  USER = 'USER',
  ADMIN = 'ADMIN',
  RM_USER = 'RM_USER',
  RM_ADMIN = 'RM_ADMIN',
  RM_DEMO = 'RM_DEMO',
  RM_DEMO_GROUP = 'RM_DEMO_GROUP'
}

export function hasRmUserOrAdminRole(roles: string[]): boolean {
  return roles.includes(Role.RM_USER) || roles.includes(Role.RM_ADMIN);
}

export function hasRmDemoRole(roles: string[]): boolean {
  return roles.includes(Role.RM_DEMO) || roles.includes(Role.RM_DEMO_GROUP);
}
